import { Box, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import { useState } from "react";
import InfoIcon from "../../../../components/icons/InfoIcon";
import { OrderId } from "../../../../types/order";
import KoluluBoxInfoBox from "../KolulaBoxInfoBox";
import CP6BoxDoor from "./CP6BoxDoor";

/* Layout
    Config | 3
    Config | 4
    1      | 5
    2      | 6
 */

const RootBox = styled(Box)(({ theme }) => ({
  backgroundColor: "black",
  width: "243px",
  height: "240px",
  margin: "0 auto",
  // boxSizing: 'border-box',
  position: "relative",
  borderRadius: "8px", // Add border-radius for rounded corners
  border: "1px solid black", // Add a solid border
  overflow: "hidden", // Add overflow to handle scrollbars or content overflow
  transform: "scale(135%) translateY(45px)",
}));

const DoorWrapper = styled(Box)({
  height: "100%",
  width: "100%",
  top: 0,
  left: 0,
  position: "relative",
});

interface CP6BoxProps {
  orderId?: OrderId;
  activeDoors: number[];
  title: string;
}

const ShadowOverlay = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9,
}));

const CP6Box = (props: CP6BoxProps) => {
  const [infoOpen, setInfoOpen] = useState<boolean>(false);
  const enableInfo = Boolean(props.orderId);

  return (
    <>
      <RootBox>
        <DoorWrapper>
          <div className="px-4 py-2 flex flex-row justify-between items-center gap-2.5 text-background">
            <h2 className="font-semibold text-base tracking-[0.32px] truncate max-w-[90%]">
              {props.title}
            </h2>
            {enableInfo && (
              <button onClick={() => setInfoOpen(true)}>
                <InfoIcon className="size-6" />
              </button>
            )}
          </div>
          {/* First Column */}
          <CP6BoxDoor
            top={42}
            left={0}
            height={99}
            doorNumber={0}
            active={props.activeDoors.includes(0)}
            isConfigBox={true}
          />
          <CP6BoxDoor
            top={142}
            left={0}
            height={49}
            doorNumber={1}
            active={props.activeDoors.includes(1)}
          />
          <CP6BoxDoor
            top={192}
            left={0}
            height={48}
            doorNumber={2}
            active={props.activeDoors.includes(2)}
          />
          {/* Second Column */}
          <CP6BoxDoor
            top={42}
            left={121}
            height={49}
            doorNumber={3}
            active={props.activeDoors.includes(3)}
          />
          <CP6BoxDoor
            top={92}
            left={121}
            height={49}
            doorNumber={4}
            active={props.activeDoors.includes(4)}
          />
          <CP6BoxDoor
            top={142}
            left={121}
            height={49}
            doorNumber={5}
            active={props.activeDoors.includes(5)}
          />
          <CP6BoxDoor
            top={192}
            left={121}
            height={48}
            doorNumber={6}
            active={props.activeDoors.includes(6)}
          />
        </DoorWrapper>
      </RootBox>
      {infoOpen && (
        <ShadowOverlay onClick={() => setInfoOpen(false)}>
          <KoluluBoxInfoBox
            onClose={() => setInfoOpen(false)}
            orderId={props.orderId!}
          />
        </ShadowOverlay>
      )}
    </>
  );
};

export default CP6Box;
